"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactTextareaAutosize = _interopRequireDefault(require("react-textarea-autosize"));

var _thinScrollbar = _interopRequireDefault(require("../thin-scrollbar/thin-scrollbar"));

var _emojiButton = _interopRequireDefault(require("../emoji-button/emoji-button"));

var _chipList = _interopRequireDefault(require("../chip-list/chip-list"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

const KEY_CODES = {
  ENTER: 13,
  BACKSPACE: 8,
  DELETE: 46
};

class FormInput extends _react.Component {
  constructor(...args) {
    super(...args);
    (0, _defineProperty2.default)(this, "onEmojiSelected", emoji => {
      const {
        onChange,
        value,
        chips,
        maxLength
      } = this.props;
      const {
        native
      } = emoji;
      const newValue = value + native;
      const isLengthExceeded = newValue.length > maxLength;

      if (isLengthExceeded) {
        return;
      }

      onChange(newValue, chips);
    });
    (0, _defineProperty2.default)(this, "onChange", e => {
      const {
        value
      } = e.target;
      const {
        onChange,
        chips,
        enableChips
      } = this.props;

      if (enableChips && value === '\n') {
        return;
      }

      onChange(value, chips);
    });
    (0, _defineProperty2.default)(this, "onKeyDown", e => {
      const {
        enableChips,
        value
      } = this.props;

      if (!enableChips) {
        return;
      }

      const {
        keyCode
      } = e;
      const newValue = e.target.value;

      switch (keyCode) {
        case KEY_CODES.ENTER:
          this.insertChip(newValue);
          break;

        case KEY_CODES.BACKSPACE:
        case KEY_CODES.DELETE:
          if (value === '') {
            this.deleteLastChip();
          }

          break;
      }
    });
    (0, _defineProperty2.default)(this, "onChipDelete", chipValue => {
      const {
        value,
        chips,
        onChange
      } = this.props;
      const newChips = [...chips];
      const chipToDeleteIndex = newChips.findIndex(chip => chip === chipValue);
      newChips.splice(chipToDeleteIndex, 1);
      onChange(value, newChips);
    });
    (0, _defineProperty2.default)(this, "onHeightChange", () => {
      if (this._scrollBarRef) {
        this._scrollBarRef.updateScroll();
      }
    });
  }

  componentDidMount() {
    const {
      onReady
    } = this.props;

    if (onReady) {
      onReady(this.inputRef);
    }
  }

  /**
   * Inserts a new chip
   * @param {string} value - chip value
   */
  insertChip(value) {
    const trimmedValue = value.trim();

    if (trimmedValue.length === 0) {
      return;
    }

    const {
      onChange,
      chips
    } = this.props;
    const chipExist = chips.find(chip => chip === trimmedValue);

    if (chipExist) {
      onChange('', chips);
      return;
    }

    onChange('', [...chips, trimmedValue]);
  }
  /**
   * Removes that last chip by chip value
   */


  deleteLastChip() {
    const {
      value,
      chips,
      onChange
    } = this.props;

    if (chips.length > 0) {
      const newChips = [...chips];
      newChips.pop();
      onChange(value, newChips);
    }
  }
  /**
   * Removes chip by value
   * @param {string} chipValue - The chip value to delete
   */


  renderWithScrollbar(children) {
    const {
      multiLine
    } = this.props;

    if (multiLine) {
      return /*#__PURE__*/_react.default.createElement(_thinScrollbar.default, {
        containerRef: ref => {
          this._scrollBarRef = ref;
        }
      }, children);
    }

    return children;
  }

  render() {
    const _this$props = this.props,
          {
      value,
      chips,
      maxLength,
      multiLine,
      enableEmoji,
      enableChips,
      className,
      style,
      showLetterLimit,
      minRows,
      onChange,
      isInvalid,
      error,
      onReady
    } = _this$props,
          otherProps = (0, _objectWithoutProperties2.default)(_this$props, ["value", "chips", "maxLength", "multiLine", "enableEmoji", "enableChips", "className", "style", "showLetterLimit", "minRows", "onChange", "isInvalid", "error", "onReady"]);

    const inputProps = _objectSpread({
      className: (0, _classnames.default)('form-input__input', {
        'form-input__input--emoji': enableEmoji
      }),
      value,
      onKeyDown: this.onKeyDown,
      ref: el => {
        this.inputRef = el;
      }
    }, otherProps);

    if (onChange) {
      inputProps.onChange = this.onChange;
    }

    if (maxLength) {
      inputProps.maxLength = maxLength;
    }

    const renderChips = enableChips && chips.length > 0;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)('form-input', className, {
        'form-input--multi-line': multiLine,
        'form-input--invalid': isInvalid
      }),
      style: style
    }, showLetterLimit && /*#__PURE__*/_react.default.createElement("span", {
      className: "form-input__letter-limit"
    }, "".concat(value.length, "/").concat(maxLength)), this.renderWithScrollbar( /*#__PURE__*/_react.default.createElement(_react.Fragment, null, renderChips && /*#__PURE__*/_react.default.createElement(_chipList.default, {
      chips: chips,
      onDelete: this.onChipDelete
    }), multiLine ? /*#__PURE__*/_react.default.createElement(_reactTextareaAutosize.default, (0, _extends2.default)({}, inputProps, {
      minRows: minRows,
      onHeightChange: this.onHeightChange
    })) : /*#__PURE__*/_react.default.createElement("input", (0, _extends2.default)({
      type: "text"
    }, inputProps)), error && /*#__PURE__*/_react.default.createElement("span", {
      className: "form-input__error"
    }, error))), enableEmoji && /*#__PURE__*/_react.default.createElement(_emojiButton.default, {
      onSelected: this.onEmojiSelected,
      className: (0, _classnames.default)('form-input__emoji-button', {
        'form-input__emoji-button--disabled': maxLength && value.length >= maxLength
      })
    }));
  }

}

(0, _defineProperty2.default)(FormInput, "propTypes", {
  value: _propTypes.default.string,
  chips: _propTypes.default.arrayOf(_propTypes.default.string),
  onChange: _propTypes.default.func,
  maxLength: _propTypes.default.number,
  multiLine: _propTypes.default.bool,
  enableEmoji: _propTypes.default.bool,
  enableChips: _propTypes.default.bool,
  className: _propTypes.default.string,
  // eslint-disable-next-line react/forbid-prop-types
  style: _propTypes.default.object,
  showLetterLimit: _propTypes.default.bool,
  minRows: _propTypes.default.number,
  isInvalid: _propTypes.default.bool,
  error: _propTypes.default.string,
  onReady: _propTypes.default.func
});
(0, _defineProperty2.default)(FormInput, "defaultProps", {
  value: '',
  chips: [],
  onChange: null,
  maxLength: null,
  enableEmoji: false,
  enableChips: false,
  multiLine: false,
  className: '',
  style: {},
  showLetterLimit: false,
  minRows: null,
  isInvalid: false,
  error: null,
  onReady: null
});
var _default = FormInput;
exports.default = _default;